import {
  ValidateIf,
  IsNotEmpty,
  IsOptional,
  IsArray,
  ArrayNotEmpty,
  IsIn,
  IsInt,
  ValidateNested,
} from 'class-validator';
import { Type } from 'class-transformer';

import { WorkflowNodeActionRole } from '@app/gen/settings';

import { BaseEventFieldsDto } from './base-event-fields.dto';
import { CompanyGroupCustomNameDto } from './company-group-custom-name.dto';

export class ExecutorFieldsDto extends BaseEventFieldsDto {
  @IsArray()
  @ArrayNotEmpty({ message: 'Обязательное поле' })
  executor: WorkflowNodeActionRole['type'][];

  @ValidateIf((dto: ExecutorFieldsDto) => dto.executor?.includes('group'))
  @ArrayNotEmpty({ message: 'Обязательное поле' })
  companyGroup?: string[];

  @ValidateNested()
  @Type(() => CompanyGroupCustomNameDto)
  @IsOptional()
  companyGroupCustomName?: CompanyGroupCustomNameDto;

  @ValidateIf((dto: ExecutorFieldsDto) => dto.executor?.includes('manager'))
  @IsIn(['operational', 'legal', 'functional'])
  @IsNotEmpty({ message: 'Обязательное поле' })
  organizationType?: 'operational' | 'legal' | 'functional';

  @ValidateIf((dto: ExecutorFieldsDto) => dto.executor?.includes('manager'))
  @IsInt()
  @IsNotEmpty({ message: 'Обязательное поле' })
  hierarchyLevel?: number;

  @ValidateIf((dto: ExecutorFieldsDto) => dto.executor?.includes('assistant'))
  @IsInt()
  @IsNotEmpty({ message: 'Обязательное поле' })
  assistantHierarchyLevel?: number;
}
